<a *ngIf="show" title="back to the top" class="back-to-top" (click)="scrollToTop()" href="javascript:void(0);">
    Top<span class="icon-el icon-el-m icon-el-s-ieoverride icon-arrow-up"></span>
</a>